import { createAction, props } from '@ngrx/store';
import { notificationReceiptLoadAdapter } from './notification-receipt.adapter';
import { NotificationState } from 'studio-components';

const ActionType = `[Notification Receipt]`;

export const notificationReceiptAction = notificationReceiptLoadAdapter.getActions();

export const CountNotificationReceiptAction = createAction(
  `${ActionType} Count`,
  props<{ state?: NotificationState }>(),
);
export const CountNotificationReceiptSucceededAction = createAction(
  `${ActionType} Count Succeeded`,
  props<{ count: number }>(),
);
export const CountNotificationReceiptErroredAction = createAction(
  `${ActionType} Count Errored`,
  props<{ error: Error }>(),
);

export const MarkAllNotificationReceiptsAction = createAction(
  `${ActionType} Mark All`,
  props<{ state: NotificationState }>(),
);
export const MarkAllNotificationReceiptsSucceededAction = createAction(
  `${ActionType} Mark All Succeeded`,
);
export const MarkAllNotificationReceiptsErroredAction = createAction(
  `${ActionType} Mark All Errored`,
  props<{ error: Error }>(),
);

export const MenuOpenedNotificationReceiptAction = createAction(`${ActionType} Menu Opened`);
export const MenuClosedNotificationReceiptAction = createAction(`${ActionType} Menu Closed`);
